import { Autocomplete, Stack, TextField, Typography } from '@mui/material'
import { t } from 'i18next'

const EventTypeFilter = ({ filters, onChange = () => { } }) => {
  const filterOptions = [
    {
      label: 'Comunicazione misura',
      value: 'measure-communication'
    },
    {
      label: 'Comunicazione',
      value: 'communication'
    },
    {
      label: 'Soglia',
      value: 'threshold'
    },
    {
      label: 'Delta',
      value: 'delta'
    },
    {
      label: 'Activation',
      value: 'activation'
    },
    {
      label: 'Trigger per misura',
      value: 'measure-trigger'
    },
    {
      label: 'Trigger schedulato',
      value: 'scheduled-trigger'
    }
  ]
  const handleChange = (_, data) => {
    onChange(data ? [data.value] : [])
  }

  return (
    <>
      <Stack
        direction="column"
        justifyContent="space-between"
        alignItems="left"
        spacing={2}
        mt={3}
        mb={3}
      >
        <Typography
          align="left"
          sx={{ fontWeight: 'bold' }}
        >
          {t('events.eventType')}
        </Typography>
        <Autocomplete
          id="events-type-filter"
          options={filterOptions}
          onChange={handleChange}
          isOptionEqualToValue={(option, value) => option.value === value}
          getOptionLabel={(option) => option?.label || ''}
          value={
            filters?.triggerTypes
              ? filterOptions.find((f) => f.value === filters?.triggerTypes[0]
              ) || ''
              : ''
          }
          renderInput={(params) => (
            <TextField
              {...params}
              variant="standard"
            />
          )}
        />
      </Stack>
    </>
  )
}

export default EventTypeFilter
